// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"sn_a bhb_a bhb_r bhb_j","Photos__img":"sn_b bhb_b"};